<template>
<ul class="m-dropdown-panel" @click.stop="">
  <slot></slot>
</ul>
</template>

<script type="text/javascript">
export default {
  name: 'MDropdownPanel'
}
</script>



// WEBPACK FOOTER //
// src/m/dropdown/dropdown-panel.vue